import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { setIsDrawerOpen } from 'redux/actions/workspace';
import { createAngelInvestorADGMLicense, updateADGMLicenseByAngelInvestorId, updateAngelInvestorById } from 'redux/actions/angelInvestors';

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    createAngelInvestorADGMLicense,
    updateADGMLicenseByAngelInvestorId,
    setIsDrawerOpen,
    updateAngelInvestorById,
  }, dispatch),
});

export default connect(null, mapDispatchToProps);
